var map = {
	"./demos/animate/index.ts": 41745,
	"./demos/avator/index.ts": 34507,
	"./demos/basic/index.ts": 58558,
	"./demos/custom/index.ts": 29509,
	"./demos/rows/index.ts": 45997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58680;